/**
 * Kanban CSS Constants
 */
/** @private */
export var ROOT_CLASS = 'e-kanban';
/** @private */
export var RTL_CLASS = 'e-rtl';
/** @private */
export var DEVICE_CLASS = 'e-device';
/** @private */
export var ICON_CLASS = 'e-icons';
/** @private */
export var TEMPLATE_CLASS = 'e-template';
/** @private */
export var SWIMLANE_CLASS = 'e-swimlane';
/** @private */
export var TABLE_CLASS = 'e-kanban-table';
/** @private */
export var HEADER_CLASS = 'e-kanban-header';
/** @private */
export var HEADER_TABLE_CLASS = 'e-header-table';
/** @private */
export var HEADER_CELLS_CLASS = 'e-header-cells';
/** @private */
export var HEADER_WRAP_CLASS = 'e-header-wrap';
/** @private */
export var HEADER_TITLE_CLASS = 'e-header-title';
/** @private */
export var HEADER_TEXT_CLASS = 'e-header-text';
/** @private */
export var HEADER_ICON_CLASS = 'e-header-icon';
/** @private */
export var STACKED_HEADER_ROW_CLASS = 'e-stacked-header-row';
/** @private */
export var STACKED_HEADER_CELL_CLASS = 'e-stacked-header-cell';
/** @private */
export var CONTENT_CELLS_CLASS = 'e-content-cells';
/** @private */
export var CONTENT_CLASS = 'e-kanban-content';
/** @private */
export var CONTENT_TABLE_CLASS = 'e-content-table';
/** @private */
export var HEADER_ROW_TOGGLE_CLASS = 'e-toggle-header';
/** @private */
export var HEADER_ROW_CLASS = 'e-header-row';
/** @private */
export var CONTENT_ROW_CLASS = 'e-content-row';
/** @private */
export var SWIMLANE_ROW_CLASS = 'e-swimlane-row';
/** @private */
export var SWIMLANE_ROW_EXPAND_CLASS = 'e-swimlane-row-expand';
/** @private */
export var SWIMLANE_ROW_COLLAPSE_CLASS = 'e-swimlane-row-collapse';
/** @private */
export var SWIMLANE_ROW_TEXT_CLASS = 'e-swimlane-text';
/** @private */
export var CARD_ITEM_COUNT_CLASS = 'e-item-count';
/** @private */
export var CARD_WRAPPER_CLASS = 'e-card-wrapper';
/** @private */
export var CARD_CLASS = 'e-card';
/** @private */
export var DRAGGABLE_CLASS = 'e-draggable';
/** @private */
export var DROPPABLE_CLASS = 'e-droppable';
/** @private */
export var DRAG_CLASS = 'e-drag';
/** @private */
export var DROP_CLASS = 'e-drop';
/** @private */
export var DISABLED_CLASS = 'e-disabled';
/** @private */
export var CARD_HEADER_CLASS = 'e-card-header';
/** @private */
export var CARD_CONTENT_CLASS = 'e-card-content';
/** @private */
export var CARD_HEADER_TEXT_CLASS = 'e-card-header-caption';
/** @private */
export var CARD_HEADER_TITLE_CLASS = 'e-card-header-title';
/** @private */
export var CARD_TAGS_CLASS = 'e-card-tags';
/** @private */
export var CARD_TAG_CLASS = 'e-card-tag';
/** @private */
export var CARD_COLOR_CLASS = 'e-card-color';
/** @private */
export var CARD_LABEL_CLASS = 'e-card-label';
/** @private */
export var CARD_FOOTER_CLASS = 'e-card-footer';
/** @private */
export var EMPTY_CARD_CLASS = 'e-empty-card';
/** @private */
export var CARD_FOOTER_CSS_CLASS = 'e-card-footer-css';
/** @private */
export var COLUMN_EXPAND_CLASS = 'e-column-expand';
/** @private */
export var COLUMN_COLLAPSE_CLASS = 'e-column-collapse';
/** @private */
export var COLLAPSE_HEADER_TEXT_CLASS = 'e-collapse-header-text';
/** @private */
export var COLLAPSED_CLASS = 'e-collapsed';
/** @private */
export var DIALOG_CLASS = 'e-kanban-dialog';
/** @private */
export var DIALOG_CONTENT_CONTAINER_CLASS = 'e-kanban-dialog-content';
/** @private */
export var FORM_CLASS = 'e-kanban-form';
/** @private */
export var FORM_WRAPPER_CLASS = 'e-kanban-form-wrapper';
/** @private */
export var ERROR_VALIDATION_CLASS = 'e-kanban-error';
/** @private */
export var FIELD_CLASS = 'e-field';
/** @private */
export var DRAGGED_CLONE_CLASS = 'e-target-dragged-clone';
/** @private */
export var CLONED_CARD_CLASS = 'e-cloned-card';
/** @private */
export var DRAGGED_CARD_CLASS = 'e-kanban-dragged-card';
/** @private */
export var DROPPED_CLONE_CLASS = 'e-target-dropped-clone';
/** @private */
export var DROPPING_CLASS = 'e-dropping';
/** @private */
export var TOGGLE_VISIBLE_CLASS = 'e-toggle-visible';
/** @private */
export var MULTI_CLONE_CONTENT_CELL_CLASS = 'e-multi-content-cell';
/** @private */
export var MULTI_CARD_WRAPPER_CLASS = 'e-multi-card-wrapper';
/** @private */
export var MULTI_ACTIVE_CLASS = 'e-multi-active';
/** @private */
export var TARGET_MULTI_CLONE_CLASS = 'e-target-multi-clone';
/** @private */
export var MULTI_COLUMN_KEY_CLASS = 'e-column-key';
/** @private */
export var CARD_SELECTION_CLASS = 'e-selection';
/** @private */
export var TOOLTIP_CLASS = 'e-kanban-tooltip';
/** @private */
export var TOOLTIP_TEXT_CLASS = 'e-tooltip-text';
/** @private */
export var SCROLL_CONTAINER_CLASS = 'e-cell-scroll-container';
/** @private */
export var SWIMLANE_HEADER_CLASS = 'e-swimlane-header';
/** @private */
export var SWIMLANE_HEADER_TOOLBAR_CLASS = 'e-swimlane-header-toolbar';
/** @private */
export var TOOLBAR_MENU_CLASS = 'e-toolbar-menu';
/** @private */
export var TOOLBAR_MENU_ICON_CLASS = 'e-icon-menu';
/** @private */
export var TOOLBAR_LEVEL_TITLE_CLASS = 'e-toolbar-level-title';
/** @private */
export var TOOLBAR_SWIMLANE_NAME_CLASS = 'e-toolbar-swimlane-name';
/** @private */
export var SWIMLANE_OVERLAY_CLASS = 'e-swimlane-overlay';
/** @private */
export var SWIMLANE_CONTENT_CLASS = 'e-swimlane-content';
/** @private */
export var SWIMLANE_RESOURCE_CLASS = 'e-swimlane-resource';
/** @private */
export var SWIMLANE_TREE_CLASS = 'e-swimlane-tree';
/** @private */
export var LIMITS_CLASS = 'e-limits';
/** @private */
export var MAX_COUNT_CLASS = 'e-max-count';
/** @private */
export var MIN_COUNT_CLASS = 'e-min-count';
/** @private */
export var MAX_COLOR_CLASS = 'e-max-color';
/** @private */
export var MIN_COLOR_CLASS = 'e-min-color';
/** @private */
export var POPUP_EVENT_CLASS = 'e-event-popup';
/** @private */
export var POPUP_HEADER_CLASS = 'e-popup-header';
/** @private */
export var CLOSE_CLASS = 'e-close';
/** @private */
export var POPUP_CONTENT_CLASS = 'e-popup-content';
/** @private */
export var POPUP_WRAPPER_CLASS = 'e-mobile-popup-wrapper';
/** @private */
export var CLOSE_ICON_CLASS = 'e-close-icon';
/** @private */
export var POPUP_OPEN_CLASS = 'e-popup-open';
/** @private */
export var DIALOG_CONTENT_CONTAINER = 'e-kanban-dialog-content';
/** @private */
export var SHOW_ADD_BUTTON = 'e-show-add-button';
/** @private */
export var SHOW_ADD_ICON = 'e-show-add-icon';
/** @private */
export var SHOW_ADD_FOCUS = 'e-show-add-focus';
/** @private */
export var FROZEN_SWIMLANE_ROW_CLASS = 'e-frozen-swimlane-row';
/** @private */
export var FROZEN_ROW_CLASS = 'e-frozen-row';
